import {
    CountsOrdersCompleted,
    CountsOrdersCreditNotes,
    CountsOrdersToBeAuthorized,
    CountsOrdersToBePlaced, CountsOrdersToBeReceived, CountsOrdersTransfers
} from '../../dto/purchase-orders/purchase-order-counts.dto';

export interface PurchaseOrderCountsQryProps {
    ordersToBePlaced?: CountsOrdersToBePlaced
    ordersToBeAuthorized?: CountsOrdersToBeAuthorized
    ordersToBeReceived?: CountsOrdersToBeReceived
    ordersTransfers?: CountsOrdersTransfers
    ordersCreditNotes?: CountsOrdersCreditNotes
    ordersCompleted?: CountsOrdersCompleted
}

export interface PurchaseOrderCounts {
    ordersToBePlaced: number;
    ordersToBeAuthorized: number;
    ordersToBeReceived: number;
    ordersTransfers: number;
    ordersCreditNotes: number;
    ordersCompleted: number;
}
